module.exports = __webpack_public_path__ + "img/3.625f4cbc.jpg";